export class ItemCategory {
    public static readonly All = '(All)';
    public static readonly Weapons = 'Weapons';
    public static readonly Armour = 'Armor';
    public static readonly Gear = 'Gear';

    public subCategories: string[];
    public validFields: string[];

    constructor(public name: string) {
        this.subCategories = [];
        this.validFields = this.getValidFields(name);
    }

    public static shouldShowDamage(category: string): boolean {
        return category == ItemCategory.Weapons;
    }

    public static shouldShowRating(category: string): boolean {
        return category == ItemCategory.Armour;
    }

    public static shouldShowShieldHitPoints(category: string): boolean {
        return category == ItemCategory.Armour;
    }

    public static shouldShowDurability(category: string): boolean {
        return category != ItemCategory.Gear;
    }

    public static shouldShowDesign(category: string): boolean {
        return category != ItemCategory.Gear;
    }
     
    public static shouldShowHands(category: string): boolean {
        return category == ItemCategory.Weapons;
    }

    public static shouldShowRange(category: string): boolean {
        return category == ItemCategory.Weapons;
    }

    private getValidFields(name: string): string[] {
        switch (name) {
            case ItemCategory.Weapons:
                return ['name', 'cost', 'damage', 'weight', 'notes'];
            case ItemCategory.Armour:
                return ['name', 'cost', 'rating', 'shieldHitPoints', 'weight', 'notes'];
            case ItemCategory.Gear:
                return ['name', 'cost', 'weight', 'notes'];
            default:
                return ['name', 'cost', 'damage', 'rating', 'weight', 'notes'];
        }
    }
}